import * as React from 'react';
import { useSelector } from 'react-redux';

import { EFieldGroupName, EFieldName } from '../../../../../../types/field';
import { TableCell, TableRow } from '../../../../../../components/Table';
import { CommonRowTitleContainer } from '../../../Field/common/CommonRowTitle';
import { selectOffers } from '../../../../../../selectors/offers';
import { selectIds } from '../../../../../../selectors/ids';
import { OfferContext } from '../../../../../../utils/offerContext';
import { TableFieldContainer } from '../../../Field';

export interface ICommonRowContainerProps {
  dragging?: boolean;
  groupName: EFieldGroupName;
  name: EFieldName;
  position: number;
  title?: string | null;
  rowRef?: React.Ref<HTMLTableRowElement>;
}

export const CommonRowContainer = ({
  dragging,
  name,
  title,
  groupName,
  position,
  rowRef,
}: ICommonRowContainerProps): React.JSX.Element => {
  const ids = useSelector(selectIds);
  const offers = useSelector(selectOffers);

  return (
    <TableRow ref={rowRef} hover>
      <TableCell>
        <CommonRowTitleContainer title={title} name={name} />
      </TableCell>
      {ids.map(id => {
        const offer = offers[id];

        return (
          <OfferContext.Provider key={`${name}/${id}`} value={offer}>
            <TableCell position={position} dragging={dragging}>
              <TableFieldContainer name={name} groupName={groupName} />
            </TableCell>
          </OfferContext.Provider>
        );
      })}
    </TableRow>
  );
};
